/* eslint-disable react-hooks/exhaustive-deps */
import { ChargingAgreement, ChargingAgreementStatus } from 'models/charging/agreement';
import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ChargingAgreementService from 'services/charging/charging-agreement.service';
import { AuthenticationContext, CustomerPermission } from 'services/context/authentication.context';

export default function DashboardChargingCta() {
  const [pendingAgreements, setPendingAgreements] = useState<ChargingAgreement[]>();
  const { state, dispatch, hasPermission } = useContext(AuthenticationContext);

  useEffect(() => {
    if (state.customerId) {
      getPendingAgreements(state.customerId);
    }
  }, [state.customerId]);

  const getPendingAgreements = async (customerId: number) => {
    try {
      const res = await ChargingAgreementService.getAgreements(customerId);

      setPendingAgreements(
        res.filter(agr => agr.status === ChargingAgreementStatus.PENDING)
      )
    } catch (e) {
      console.error(e);
    }
  };

  const hasPendingAgreements = !!pendingAgreements?.length;
  if(!hasPendingAgreements) return null;

  return (
    <Card className="d-flex flex-col p-4 mb-4">
      <div className="d-flex flex-row flex-nowrap align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <i className="icon__charging mr-2"></i>
          <strong className="u-fs-16">
            Teile on tehtud laadimislepingu pakkumine.
          </strong>
        </div>
        {pendingAgreements?.length === 1 && hasPermission(CustomerPermission.WEB_ADMIN) ? (
          <div>
            <Link
              to="/laadimine/leping"
              onClick={() =>
                dispatch({
                  type: 'setViewChargingOffer',
                  value: pendingAgreements[0],
                })
              }
              className="btn btn-secondary-medium d-flex align-items-center text-nowrap"
            >
              Vaata pakkumist
              <i className="icon__arrow-right bg-dark ml-2" />
            </Link>
          </div>
        ) : (
          <Link
            to="/lepingud"
            className="btn btn-secondary-medium d-flex align-items-center text-nowrap"
          >
            Vaata lepinguid
            <i className="icon__arrow-right bg-dark ml-2" />
          </Link>
        )}
      </div>
    </Card>
  );
}
